import React, { useMemo } from 'react';
import { Grid, IconType, ISelectOption, RotatingIcon, SelectField } from '../../../../ui-toolkit';
import { PreExistingContactDisplay } from '../subComponents/PreExistingContactDisplay';
import { IAdminUserData } from '../../../../types/administration/userAdministration/IAdminUser';
import { IPageData } from '../../../../types/rest/IPageData';
import { useFormikContext } from 'formik';
import { IInternalContactRequest } from '../../../../types/contacts/IInternalContact';

interface IAddContactFormAdminSectionProps {
  onSelectAdmin: (adminId: string) => void;
  adminUsersData: IPageData<IAdminUserData>;
  getAdminUsersSuccess: boolean;
}
export const AddContactFormAdminSection2: React.FC<IAddContactFormAdminSectionProps> = ({
  onSelectAdmin,
  adminUsersData,
  getAdminUsersSuccess,
}) => {
  const { getFieldProps } = useFormikContext<IInternalContactRequest>();
  const { value } = getFieldProps<string | undefined>('adminId');

  const adminsOptions: ISelectOption<string>[] = useMemo(
    () =>
      adminUsersData.content.map((admin) => ({
        label: admin.fullName,
        value: admin.id,
      })),
    [adminUsersData]
  );

  const contact = adminUsersData.content.find((admin) => admin.id === value);

  return (
    <Grid templateColumns={!getAdminUsersSuccess ? '1fr min-content' : '1fr'} alignItems={'center'}>
      <Grid>
        <SelectField
          name={'adminId'}
          onChange={(adminId: string = '') => {
            onSelectAdmin(adminId);
          }}
          isClearable
          label={'Find Existing Contact'}
          options={adminsOptions}
          value={adminsOptions.find((admin) => admin.value === value) ?? null}
        />
        {value && !!contact && <PreExistingContactDisplay fullName={contact.fullName} email={contact.email} />}
      </Grid>
      {!getAdminUsersSuccess && <RotatingIcon type={IconType.Loading} />}
    </Grid>
  );
};
